import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import "./Auth.css";

const RegisterPage = () => {
  const navigate = useNavigate();
  const register = useAuthStore((state) => state.register);
  const error = useAuthStore((state) => state.error);
  const isLoading = useAuthStore((state) => state.isLoading);

  const [formData, setFormData] = useState({
    email: "", firstName: "", lastName: "", password: "", passwordConfirm: "",
  });
  const [passwordError, setPasswordError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "passwordConfirm" || name === "password") {
      const other = name === "password" ? formData.passwordConfirm : formData.password;
      setPasswordError(value && other && value !== other ? "Las contraseñas no coinciden" : "");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.passwordConfirm) {
      setPasswordError("Las contraseñas no coinciden");
      return;
    }
    const result = await register(formData);
    if (result.success) navigate("/dashboard");
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>MercadoPrestamos</h1>
        <h2>Crear Cuenta Administrativa</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="firstName">Nombre</label>
            <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="Juan" />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Apellido</label>
            <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Pérez" />
          </div>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="ejemplo@correo.com" />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} required placeholder="Mínimo 6 caracteres" />
          </div>
          <div className="form-group">
            <label htmlFor="passwordConfirm">Confirmar Contraseña</label>
            <input type="password" id="passwordConfirm" name="passwordConfirm" value={formData.passwordConfirm} onChange={handleChange} required placeholder="Confirmar contraseña" />
            {passwordError && <span className="error-text">{passwordError}</span>}
          </div>
          <button type="submit" className="btn-primary" disabled={isLoading || !!passwordError}>
            {isLoading ? "Registrando..." : "Registrarse"}
          </button>
        </form>
        <p className="auth-footer">
          ¿Ya tiene cuenta? <Link to="/login">Ingresar aquí</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
